export default __webpack_public_path__ + "static/media/36I-120841_-43990_0.44843bb7.jpg";